module.exports = __webpack_public_path__ + "img/IMG-20181117-WA0012.3c59afdc.jpg";